@if (map()) {
  <div class="store-map-container">
    <bt-map [map]="map()" size="medium" zoom="fill" (load)="onMapLoad($event)" [canvasOptions]="canvasOptions"></bt-map>
  </div>
}
